import { 
  Image as VanImage, Loading, Swipe, SwipeItem, FloatingBubble,
  Popover, Tab, Tabs, Icon, List, Cell, CellGroup ,ConfigProvider, Field, Button,Form,Popup,Toast,Picker,Uploader,Dialog,Col,Row,
  Empty,Area,Sticky,Locale
} from 'vant'

import 'vant/lib/index.css'
import { zhCN } from 'vant/lib/locale/lang/zh-CN'

// 需要使用的组件列表
const components = [
  VanImage, Loading, Swipe, SwipeItem, FloatingBubble, 
  Popover, Tab, Tabs, Icon, List, Cell, CellGroup, ConfigProvider, Field, Button,Form,Popup,Toast,Picker,Uploader,Dialog,Col,Row,
  Empty,Area,Sticky
]

// 导出一个 Vue 插件
export function setupVant(app) {
  // 设置语言
  Locale.use('zh-CN', zhCN)

  // 注册组件
  components.forEach(component => {
    app.use(component)
  })

}